import CreditCapabilities from '../../../views/credit/CreditCapabilities/index.js';

export const requirements = {
  flipFlopRequirements: [],
};

export const verifier = () => CreditCapabilities.canEnterOffersPage();
